// The knob is separate because one control makes the whole row clickable and
// carries `role="switch"` itself; there it needs the look without the button.
// Every length is a rem step so the knob stays inside the track: this page's
// root is 14px, where the earlier hand-written `translate-x-[25px]` overshot.
export function SwitchTrack({ checked }: { checked: boolean }) {
  return (
    <span aria-hidden="true" className={`relative block h-7 w-12 shrink-0 rounded-full transition-colors ${checked ? 'bg-gold-deep' : 'bg-bone ring-1 ring-inset ring-rule-strong'}`}>
      <span data-switch-knob="" className={`absolute left-0 top-1 size-5 rounded-full bg-paper shadow transition-transform ${checked ? 'translate-x-6' : 'translate-x-1'}`} />
    </span>
  )
}

export function Switch({
  checked,
  label,
  disabled = false,
  onChange,
}: {
  checked: boolean
  label: string
  disabled?: boolean
  onChange: () => void
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={onChange}
      className="shrink-0 rounded-full disabled:opacity-50"
    >
      <SwitchTrack checked={checked} />
    </button>
  )
}
